import SessionTimerModal from './SessionTimerModal';
export default SessionTimerModal;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/SessionTimerModal/index.js
// module id = 464
// module chunks = 8